'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chatMessageReceived = undefined;

var _defaultMessageReceived = require('../../actions/defaultMessageReceived');

var _dismissTypingIndicator = require('../../typing-indicators/actions/dismissTypingIndicator');

var _resolveAttachmentsForMessage = require('../../resolved-attachments/actions/resolveAttachmentsForMessage');

var chatMessageReceived = exports.chatMessageReceived = function chatMessageReceived(message, channel) {
  return function (dispatch) {
    dispatch((0, _dismissTypingIndicator.dismissTypingIndicator)(message));
    dispatch((0, _defaultMessageReceived.defaultMessageReceived)(message, channel));
    dispatch((0, _resolveAttachmentsForMessage.resolveAttachmentsForMessage)(message));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/actions/chatMessageReceived.js
// module id = 421
// module chunks = 2 3